import { useSelector } from 'react-redux';

export const useNavOpen = () => {
    return useSelector(({ nav: { open } }) => open);
};

export const useNavStructure = () => {
    return useSelector(({ nav: { structure } }) => structure);
};
